import PropTypes from "prop-types";
import { Button, useClipboard } from "@chakra-ui/react";
import React from "react";
import { FaCopy } from "react-icons/fa";
import { useTranslation } from "react-i18next";

export const Clipboard = ({ value, withText, variant, fullwidth, size }) => {
  const { onCopy, hasCopied } = useClipboard(value, 3000);
  const { t } = useTranslation(["common"]);

  return withText ? (
    <Button
      onClick={onCopy}
      leftIcon={<FaCopy />}
      variant={variant}
      isFullWidth={fullwidth}
      size={size}
      isActive={hasCopied}
      _active={{ color: "brand.primary" }}
    >
      {hasCopied ? t("copied") : t("copy")}
    </Button>
  ) : (
    <>
      <Button
        onClick={onCopy}
        variant="unstyled"
        size="sm"
        isActive={hasCopied}
        _active={{ color: "brand.primary" }}
      >
        <FaCopy /> {hasCopied && t("copied")}
      </Button>
    </>
  );
};

Clipboard.propTypes = {
  size: PropTypes.string,
}

Clipboard.defaultProps = {
  size: "md"
}
